'use client';

import { useMedia } from '@ssv-website/hooks';
import { useEffect, useRef, useState } from 'react';

const LiveVideoContainerPC = ({
  src = '',
  className,
}: {
  src?: string;
  className?: string;
}) => {
  const url = new URL(src);
  const configQuery = {
    qudao: 'ssv',
    hideNavbar: 1,
    isIframe: 1,
  };
  Object.entries(configQuery).forEach(([key, value]) => {
    url.searchParams.append(key, String(value));
  });
  const liveUrl = url.toString();
  const liveBoxRef = useRef<HTMLDivElement>(null);
  const [liveSize, setLiveSize] = useState({ width: 0, height: 0 });
  const [transform, setTransform] = useState('');

  const updateLiveSize = () => {
    const liveBox = liveBoxRef.current;
    if (liveBox) {
      const { width, height } = liveBox.getBoundingClientRect();
      setLiveSize({ width, height });
    }
  };

  useEffect(() => {
    updateLiveSize();
    window.addEventListener('resize', updateLiveSize);
    return () => {
      window.removeEventListener('resize', updateLiveSize);
    };
  }, []);
  const ORIGINAL_VIDEO_WIDTH = 1080;
  const ORIGINAL_VIDEO_HEIGHT = 630;
  useEffect(() => {
    const { width: parentWidth, height: parentHeight } = liveSize;
    if (parentWidth === 0 || parentHeight === 0) return;
    const scaleX = parentWidth / ORIGINAL_VIDEO_WIDTH;
    const scaleY = parentHeight / ORIGINAL_VIDEO_HEIGHT;
    const scale = Math.min(scaleX, scaleY);
    setTransform(`translate(-50%, -50%) scale(${scale})`);
  }, [liveSize]);

  return (
    <div
      className={`relative flex-1 min-h-0 bg-[#0f0f0f] ${className}`}
      ref={liveBoxRef}
    >
      {/* 折罩层 */}
      <div
        className="absolute w-full h-full z-10 bg-[#0f0f0f]"
        style={{
          display: transform ? 'none' : 'block',
        }}
      ></div>
      {/* 直播 */}
      <div
        className={`absolute w-[1080px] h-[630px] left-1/2 top-1/2 overflow-hidden `}
        style={{
          transform: `${transform}`,
        }}
      >
        <iframe
          title="s2025大会直播"
          className="absolute w-[1080px] h-[630px] overflow-hidden"
          src={liveUrl}
          allow="fullscreen"
          sandbox="allow-same-origin allow-scripts"
          scrolling="no"
        ></iframe>
      </div>
    </div>
  );
};

const LiveVideoContainerMobile = ({
  src = '',
  className,
}: {
  src?: string;
  className?: string;
}) => {
  const url = new URL(src);
  const configQuery = {
    qudao: 'ssv',
    hideNavbar: 1,
    isIframe: 1,
  };
  Object.entries(configQuery).forEach(([key, value]) => {
    url.searchParams.append(key, String(value));
  });
  const liveUrl = url.toString();

  return (
    <div className={`flex-1 min-h-0 w-full ${className}`}>
      <div className={`w-full h-full overflow-hidden`}>
        <iframe
          title="s2025大会直播"
          className="w-full h-full overflow-hidden touch-none"
          src={liveUrl}
          allow="fullscreen"
          sandbox="allow-same-origin allow-scripts"
          scrolling="no"
        ></iframe>
      </div>
    </div>
  );
};

export default function LiveVideoContainer({
  src = '',
  className,
}: {
  src?: string;
  className?: string;
}) {
  const isMobile = useMedia('mobile');
  console.log(isMobile);

  return (
    <>
      {!isMobile && (
        <LiveVideoContainerPC
          key={'pc'}
          className={`${className} mobile:hidden`}
          src={src}
        ></LiveVideoContainerPC>
      )}
      {isMobile && (
        <LiveVideoContainerMobile
          key={'mobile'}
          className={`${className} hidden mobile:block`}
          src={src}
        ></LiveVideoContainerMobile>
      )}
    </>
  );
}
